/* tslint:disable */

/**
 */
export class FormLoginMembership {
    username?: string;
    password?: string;
}
